// This JSON object corresponds to the spreadsheet: Ball Results.xlsx
import BallResults from '../BallResults.json';

function getRunsAndWickets(over) {
    let runs = 0;
    let wickets = 0;

    // Get number of runs scored for each bowl in the over
    for (let i = 1; i <= 10; i++) {
        const bowlValue = over['b' + i];

        if (bowlValue === null || bowlValue.length === 0) {
            continue;
        }

        const result = BallResults[bowlValue.toLowerCase()];

        if (result) {
            runs += result.runs;
            wickets += result.wickets;
        }
    }

    return { runs, wickets };
}

export default function getRunsPerOver(overs) {
    const { inns1, inns2 } = overs || {};

    let runsPerOver = [];

    let innings1TotalRuns = 0;
    let innings2TotalRuns = 0;

    if (inns1) {
        inns1.forEach(over => {
            let result = {
                over: over.ov,
                innings1Runs: 0,
                innings2Runs: 0,
                innings1Wickets: 0,
                innings2Wickets: 0,
            };

            // Find out whether there is already a data point for this over
            const existingDataIndex = runsPerOver.findIndex(data => data.over === over.ov);

            if (existingDataIndex !== -1) {
                result = runsPerOver[existingDataIndex];
            }

            const { runs, wickets } = getRunsAndWickets(over);

            result.innings1Runs = runs;
            result.innings1Wickets = wickets;
            innings1TotalRuns += runs;
            result.innings1TotalRuns = innings1TotalRuns;

            if (existingDataIndex !== -1) {
                runsPerOver[existingDataIndex] = result;
            } else {
                runsPerOver.push(result)
            }
        })
    }

    if (inns2) {
        inns2.forEach(over => {
            let result = {
                over: over.ov,
                innings1Runs: 0,
                innings2Runs: 0,
                innings1Wickets: 0,
                innings2Wickets: 0,
            };

            // Find out whether there is already a data point for this over
            const existingDataIndex = runsPerOver.findIndex(data => data.over === over.ov);

            if (existingDataIndex !== -1) {
                result = runsPerOver[existingDataIndex];
            }

            const { runs, wickets } = getRunsAndWickets(over);

            result.innings2Runs = runs;
            result.innings2Wickets = wickets;
            innings2TotalRuns += runs;
            result.innings2TotalRuns = innings2TotalRuns;

            if (existingDataIndex !== -1) {
                runsPerOver[existingDataIndex] = result;
            } else {
                runsPerOver.push(result)
            }
        })
    }


    return runsPerOver;
}
